import { Shelf, Stack } from "capitalrx-components-2.0/lib/layout";
import { Body, Heading, Semibold } from "capitalrx-components-2.0/lib/typography";
import { FC } from "react";
import { useTranslation, Trans } from "react-i18next";

export const UnifiedInformation: FC = () => {
  const { t: translate } = useTranslation();

  return (
    <Stack spacing="large">
      <Stack>
        <Heading>{translate("MEMBER_ID_CARD_PAGE.preCertification")}</Heading>
        <Body>
          {translate("MEMBER_ID_CARD_PAGE.callJudiHealth")}
          <a href="tel:1-833-599-1020">
            <Semibold>1-833-599-1020</Semibold>
          </a>
        </Body>
        <Body>
          <Trans
            i18nKey="MEMBER_ID_CARD_PAGE.preCertificationMessage"
            components={{ br: <><br /><br /></> }}
          />
        </Body>
      </Stack>
      <Stack>
        <Heading>{translate("MEMBER_ID_CARD_PAGE.memberClaims")}</Heading>
        <Body>
          <Stack spacing="none">
            <p>
              <Semibold>Cigna Medical Claims</Semibold>
            </p>
            <p>PO Box 188061</p>
            <p>Chattanooga, TN 37422 - 8061</p>
          </Stack>
        </Body>
        <Body>
          <Stack spacing="none">
            <p>
              <Semibold>{translate("MEMBER_ID_CARD_PAGE.electronicPayerId")}:</Semibold> 62308
            </p>
            <p>
              {translate("MEMBER_ID_CARD_PAGE.cignaWebsiteMessage")} <a href="https://www.myCigna.com">www.myCigna.com</a>
            </p>
          </Stack>
        </Body>
        <Body>*{translate("MEMBER_ID_CARD_PAGE.cignaBenefitsDisclosure")}</Body>

        <Shelf>
          <Body
            style={{
              color: "white",
              backgroundColor: "black",
              padding: "4px 8px 4px 8px",
            }}
          >
            <Semibold>Away from Home Care</Semibold>
          </Body>
          <Shelf.Spacer />
        </Shelf>
      </Stack>

      <Stack>
        <Heading>Rx Claims</Heading>
        <Body>
          <Stack spacing="none">
            <Semibold>Capital Rx</Semibold>
            <p>Attn: Claims</p>
            <p>9450 SW Gemini Dr. #87234</p>
            <p>Beaverton, Oregon 97008-7105</p>
          </Stack>
        </Body>

        <Body>
          <Stack spacing="none">
            <Semibold>{translate("MEMBER_ID_CARD_PAGE.memberPharmacyHelpLine")}:</Semibold>
            <a href="tel:1-833-599-1020">1-833-599-1020</a>
          </Stack>
        </Body>
      </Stack>
    </Stack>
  );
};
